export var MeasurementOperation;
(function (MeasurementOperation) {
    MeasurementOperation["CROSS_SECTION"] = "crossSection";
    MeasurementOperation["LINEAR"] = "linear";
    MeasurementOperation["DISTANCE"] = "distance";
})(MeasurementOperation || (MeasurementOperation = {}));
//# sourceMappingURL=measurement-interface.js.map